import * as React from 'react';

import { cn } from '../../../lib/utils';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface CodeCellProps {
  children: React.ReactNode;
  className?: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

/**
 * Monospace code cell for data table columns.
 * Replaces the repeated `<span className="font-mono text-xs text-muted-foreground">` pattern.
 */
export function CodeCell({ children, className }: CodeCellProps): React.JSX.Element {
  return <span className={cn('font-mono text-xs text-muted-foreground', className)}>{children}</span>;
}
